import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="action-text-link"
export default class extends Controller {
	connect() {
		this.addAttribute();
	}

	addAttribute() {
		// Find all anchor tags within the Action Text content
		const links = this.element.querySelectorAll("a");

		links.forEach(link => {
			// Set the data-turbo-frame attribute to target a specific frame, e.g., 'main_frame'
			// You may want to adjust the target logic based on your application's needs
			this.allowed_domain(link)
		});
	}

	allowed_domain(el) {
		const url = el.getAttribute('href');
		const domain = /amekabu.com/;
		if (domain.test(url)) {
			el.setAttribute("data-turbo-frame", "_top");
		} else {
			el.setAttribute("target", "_blank");
			el.setAttribute("rel", "dofollow");
		}
	}
}